import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { style: {"line-height":"2","text-align":"left"} }
const _hoisted_4 = {
  class: "dialog-footer",
  style: {"text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_select_v2, {
        class: "filter-item",
        filterable: "",
        modelValue: _ctx.filters.sale_channel_id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.sale_channel_id) = $event)),
        clearable: "",
        options: _ctx.saleChannelList,
        props: _ctx.saleListProps,
        placeholder: "请选择销售渠道名称"
      }, null, 8, ["modelValue", "options", "props"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: _ctx.filters.close_start_time,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.close_start_time) = $event)),
        placeholder: "请选择关卡开始时间",
        "value-format": "YYYY-MM-DD",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: _ctx.filters.close_end_time,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.close_end_time) = $event)),
        placeholder: "请选择关卡结束时间",
        "value-format": "YYYY-MM-DD",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.ids,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.ids) = $event)),
        modelModifiers: { trim: true },
        placeholder: "券码ID，多个以英文逗号分隔",
        title: _ctx.filters.ids,
        clearable: ""
      }, null, 8, ["modelValue", "title"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.start_id,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.start_id) = $event)),
        modelModifiers: { trim: true },
        placeholder: "券码开始ID",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.end_id,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.end_id) = $event)),
        modelModifiers: { trim: true },
        placeholder: "券码结束ID",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: _ctx.filters.status,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.status) = $event)),
        placeholder: "关卡状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "已关",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "已开",
            value: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSearch()))
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onExport()))
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createTextVNode("批量导出")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _ctx.openCardDialog
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [
          _createTextVNode("开卡")
        ])),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_el_table, {
      data: _ctx.tableData,
      ref: "couponList",
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "券码ID",
          width: "90"
        }),
        _createVNode(_component_el_table_column, {
          prop: "coupon_no",
          label: "券码编号",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "sale_channel",
          label: "渠道名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "amount",
          label: "面值",
          width: "70"
        }),
        _createVNode(_component_el_table_column, {
          prop: "coupon_discount",
          label: "结算折扣",
          width: "70"
        }),
        _createVNode(_component_el_table_column, { label: "卡券形式" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.coupon_type_val), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "卡券类型" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.charge_coupon_type_val), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "卡券属性" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.coupon_attribute_val), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "company_name",
          label: "公司"
        }),
        _createVNode(_component_el_table_column, {
          prop: "salesman_name",
          label: "销售人员"
        }),
        _createVNode(_component_el_table_column, {
          prop: "status_val",
          label: "卡券状态",
          width: "80"
        }),
        _createVNode(_component_el_table_column, {
          label: "蛋糕余额有效期",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            (scope.row.valid_from!==null && scope.row.valid_from!=='0000-00-00')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(`${scope.row.valid_from} 至 ${scope.row.valid_to}`), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "出卡有效期",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            (scope.row.bind_from!==null && scope.row.bind_from!=='0000-00-00')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(`${scope.row.bind_from} 至 ${scope.row.bind_to}`), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "close_time",
          label: "关卡时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "remain_money",
          label: "关卡金额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "status_close_val",
          label: "关卡状态"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_Pagination, {
      currentPage: _ctx.filters.page,
      total: _ctx.total,
      pageSize:  _ctx.filters.page_size,
      onPageChange: _ctx.onPageChange,
      onSizeChange: _ctx.onSizeChange
    }, null, 8, ["currentPage", "total", "pageSize", "onPageChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "开卡后，用户将恢复使用",
      modelValue: _ctx.noticeDialog,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.noticeDialog) = $event)),
      "before-close": _ctx.closeCardDialog,
      width: "300px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, { onClick: _ctx.closeCardDialog }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.switchCard()))
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode("开卡")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, "开卡数量：" + _toDisplayString(_ctx.cardData.quantity), 1),
          _createElementVNode("div", null, "共计金额：" + _toDisplayString(_ctx.cardData.amount) + " 元", 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ]))
}